import { BaseResponse } from "../../../../../../../types/api/api.types";
import { CreateProspectDIRRequestData } from "../../../../../../../types/api/endpoints/prospect/create.types";
import { PROSPECT_ENDPOINTS } from "../../../../../../../utils/api/endpoints/prospectEndpoints";

const PREFIX = '[createProspectDIRQuery]';

export const CREATE_PROSPECT_DIR_QUERY_KEY = 'CREATE_PROSPECT_DIR';

export const createProspectDIRQuery = async (data: CreateProspectDIRRequestData) => {
  console.log(PREFIX, `Requesting prospect account creation from DIR...`);
  const response = await PROSPECT_ENDPOINTS.createProspectFromDIR(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received prospect account creation from DIR.`);
  return json as BaseResponse;
};
